import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { paymentService } from '@/services/paymentService';

// `enabled` lets a caller that renders for logged-OUT users too (selectedCarDetailsLatest
// shows the card row only when signed in) skip the request instead of firing one that is
// guaranteed to 401. Defaults to true, so existing callers are unchanged.
export function usePaymentMethods({enabled = true} = {}) {
  return useQuery({
    enabled,
    queryKey: ['payment-methods'],
    queryFn: async () => {
      const result = await paymentService.getPaymentMethods();
      if (!result.success) throw new Error(result.error);
      return result.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useInvalidatePaymentMethods() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ['payment-methods'] });
}

export function useSetDefaultPaymentMethod() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => paymentService.setDefaultPaymentMethod(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payment-methods'] });
    },
  });
}

export function useDeletePaymentMethod() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const result = await paymentService.deletePaymentMethod(id);
      if (!result.success) throw new Error(result.error || 'Failed to delete payment method');
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payment-methods'] });
    },
  });
}
